__webpack_require__.p = "/candidate-standalone/referrals-hub/";